<script setup>
import { Link } from '@inertiajs/vue3'
</script>

<template>
  <ul class="flex items-baseline space-x-4">
    <li>
      <Link
        :href="route('login')"
        class="group border-b-2 border-transparent p-1 text-sm font-medium text-gray-500 hover:border-link-hover hover:text-link"
      >
        Login
      </Link>
    </li>

    <li>
      <Link
        :href="route('register')"
        class="group border-b-2 border-transparent p-1 text-sm font-medium text-gray-500 hover:border-link-hover hover:text-link"
      >
        Register
      </Link>
    </li>
  </ul>
</template>
